// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"390":"7e31f15a","486":"589edc0b"}[chunkId] + ".chunk.css";
};